import repository from './repsitory'

const resource = '/paymentMethod'

export default {
    get () {
        return repository.get(`${resource}`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
}
